import React from "react";

import { DialogProps, DialogTitle, Divider, } from "@mui/material";
import { Breakpoint } from "@mui/system";

import BarekamText from "../../text";
import BarekamButton, { DialogButtons, OrderButtons } from "../../button";
import Message from "../../message";
import { MessageSections } from "../../message/message";
import { BarekamDialog, BarekamMobileDialog, DialogActionsContainer, DialogButtonContainer } from "./styled";
import { useAppSelector } from "../../../../redux/store";
import { OrderModel } from "../../../shared/models/order/order-item.model";
import { BarekamIcon } from "../../icon/barekam-icon";
import { AttachmentIcons } from "../../icon/variants";
import { exportToExcel } from "../../../shared/helper-functions";

export const StandardDialog = ({ headerLabel, children, width, onCancel, ...props }: StandardDialogProps) => {
    const { matchesPhone } = useAppSelector(state => state.deviceReducer);

    if (!props?.open) {
        return null;
    }

    const DialogContent = () => (
        <>
            <DialogTitle>
                {headerLabel}
            </DialogTitle>

            <Divider style={{ width: '100%' }} />

            {children}

            <Divider style={{ width: '100%' }} />

            {onCancel && (
                <BarekamButton type={DialogButtons.CANCEL} onClick={onCancel} size="s" className="modal-close">
                    <BarekamText variant={'s'} fontWeight={500}>
                        <Message messageKey={'cancel'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </BarekamButton>
            )}
        </>
    )

    if (matchesPhone) {
        return (
            <BarekamMobileDialog {...props} hideBackdrop fullWidth>
                <DialogContent />
            </BarekamMobileDialog>
        )
    } else {
        return (
            <BarekamDialog {...props} maxWidth={matchesPhone ? 'xl' : width || 'sm'} hideBackdrop fullWidth>
                <DialogContent />
            </BarekamDialog>
        )
    }
}

export const StandardDialogFooter = ({ saveLabel, onSave, onCancel, exportableOrders }: StandardDialogFooterProps) => {
    const { orderStateId } = useAppSelector(state => state.ordersReducer);
    const { orderStates, currentRate } = useAppSelector(state => state.staticDataReducer);

    function onExport() {
        let fileName = '';
        if (typeof orderStateId === 'number') {
            fileName = orderStates.find(state => state.orderStateId === orderStateId)?.name || '';
        } else {
            fileName = orderStateId;
        }

        exportToExcel(fileName, exportableOrders || [], currentRate);
    }

    return (
        <DialogActionsContainer>
            {
                !!exportableOrders && exportableOrders.length ?
                    <BarekamButton type={OrderButtons.EXPORT} size={"s"} onClick={onExport}>
                        <BarekamIcon variant={AttachmentIcons.download} />

                        <BarekamText variant={"m"} bold>
                            <Message messageKey={"export"} sectionId={MessageSections.ORDERS} />
                        </BarekamText>
                    </BarekamButton>
                    : ''
            }
            <DialogButtonContainer>
                <BarekamButton type={DialogButtons.CANCEL}
                    onClick={() => onCancel()}>
                    <BarekamText variant={'s'} fontWeight={500}>
                        <Message messageKey={'cancel'} sectionId={MessageSections.MAIN} />
                    </BarekamText>
                </BarekamButton>

                {saveLabel
                    ? <BarekamButton type={DialogButtons.SAVE}
                        onClick={() => onSave && onSave()}>
                        <BarekamText variant={'s'} fontWeight={700}>
                            {saveLabel}
                        </BarekamText>
                    </BarekamButton>
                    : ''
                }

            </DialogButtonContainer>
        </DialogActionsContainer>
    )
}

interface StandardDialogFooterProps {
    saveLabel?: JSX.Element,
    onSave?: () => void,
    onCancel: () => void,
    exportableOrders?: OrderModel[]
}

interface StandardDialogProps extends DialogProps {
    headerLabel: JSX.Element,
    width?: Breakpoint
    onCancel?: () => void,
}